var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"15","height":"10","viewBox":"0 0 18 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7 12H11V10H7V12ZM0 0V2H18V0H0ZM3 7H15V5H3V7Z","fill":"#4A86D1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }